'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
var slicedToArray = require('../../slicedToArray-a8a77f0e.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../Icon-efcd1bee.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../Typography/Typography.js');
require('../../utils/ref/refType.js');
require('../../withIntlAriaAttrs-d3af74a8.js');
var components_Button_Button = require('../Button/Button.js');
var components_LockScroll_LockScroll = require('../LockScroll/LockScroll.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    transform: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var ORIGIN_DIRECTION = {
  top: 'translate3d(0, -100%, 0)',
  right: 'translate3d(100%, 0, 0)',
  bottom: 'translate3d(0, 100%, 0)'
};
var DrawerContainer = styled__default['default'].div.withConfig({
  displayName: "Drawer__DrawerContainer",
  componentId: "t9dmka-0"
})(["background:", ";position:fixed;right:0;top:0;height:100%;max-width:100%;width:", ";will-change:transform;z-index:4000;transition:300ms;overflow-x:hidden;transform:", ";", ""], styles_themeUtils.nuDSColor('white'), function (props) {
  return props.width;
}, function (props) {
  return props.open ? 'translate3d(0, 0, 0)' : ORIGIN_DIRECTION[props.direction];
}, styles_breakpoints.tablet768(_templateObject(), function (props) {
  return props.open ? 'translate3d(0, 0, 0)' : ORIGIN_DIRECTION[props.desktopDirection];
}));
DrawerContainer.propTypes = {
  desktopDirection: index.propTypes.string.isRequired,
  direction: index.propTypes.string.isRequired,
  open: index.propTypes.bool.isRequired,
  width: index.propTypes.string.isRequired
};
DrawerContainer.displayName = 'DrawerContainer';

var handleVisibility = function handleVisibility(_ref) {
  var open = _ref.open;

  if (open) {
    return styled.css(["opacity:1;pointer-events:auto;"]);
  }

  return styled.css(["opacity:0;pointer-events:none;"]);
};

var BodyOverlay = styled__default['default'].div.withConfig({
  displayName: "BodyOverlay",
  componentId: "ra706l-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:3000;overflow:hidden;", ";transform:translate3d(0,0,0);background:", ";transition:opacity 50ms ease-out 0s,transform 50ms ease-in-out 0s;"], handleVisibility, styles_themeUtils.nuDSColor('black', 'defaultT70'));
BodyOverlay.propTypes = {
  open: index.propTypes.bool.isRequired
};
BodyOverlay.displayName = 'BodyOverlay';

var DrawerContext = /*#__PURE__*/React.createContext({
  hideCloseButton: false,
  toggleCloseButton: function toggleCloseButton() {}
});

function setButtonVisibility(_ref) {
  var hideCloseButton = _ref.hideCloseButton;

  if (hideCloseButton) {
    return styled.css(["& > button{display:none;}"]);
  }

  return undefined;
}

var DrawerHeaderWrapper = styled__default['default'].header.withConfig({
  displayName: "DrawerHeaderWrapper",
  componentId: "sc-14x714s-0"
})(["display:flex;justify-content:flex-end;align-items:center;width:100%;background:", ";padding:1rem;flex-shrink:0;& > button{height:3rem;}", ""], styles_themeUtils.nuDSColor('white'), setButtonVisibility);
DrawerHeaderWrapper.propTypes = {
  hideCloseButton: index.propTypes.bool.isRequired
};
DrawerHeaderWrapper.displayName = 'DrawerHeaderWrapper';

var DrawerHeader = function DrawerHeader(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var drawerCtx = React.useContext(DrawerContext);
  return /*#__PURE__*/React__default['default'].createElement(DrawerHeaderWrapper, {
    className: className,
    hideCloseButton: drawerCtx.hideCloseButton
  }, children);
};

DrawerHeader.defaultProps = {
  className: undefined
};
DrawerHeader.propTypes = {
  children: index.propTypes.node.isRequired,
  className: index.propTypes.string
};

var DrawerCloseButton = function DrawerCloseButton(_ref) {
  var onClick = _ref.onClick,
      title = _ref.title;
  var createButtonRef = React.useRef(null);
  React.useEffect(function () {
    if (createButtonRef && createButtonRef.current) {
      createButtonRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React__default['default'].createElement(components_Button_Button['default'], {
    ref: createButtonRef,
    variant: "basic",
    styleVariant: "primary",
    onClick: onClick,
    iconProps: {
      name: 'x',
      title: title
    }
  });
};

DrawerCloseButton.defaultProps = {
  title: 'Close'
};
DrawerCloseButton.propTypes = {
  onClick: index.propTypes.func.isRequired,
  title: index.propTypes.string
};

var DrawerContentWrapper = styled__default['default'].div.withConfig({
  displayName: "DrawerContentWrapper",
  componentId: "sc-1kkla03-0"
})(["display:flex;flex-direction:column;overflow-y:auto;height:100%;"]);
DrawerContentWrapper.displayName = 'DrawerContentWrapper';

var DrawerContent = function DrawerContent(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default['default'].createElement(DrawerContentWrapper, {
    className: className
  }, children);
};

DrawerContent.defaultProps = {
  className: undefined
};
DrawerContent.propTypes = {
  children: index.propTypes.node.isRequired,
  className: index.propTypes.string
};

var ESCAPE_KEY_CODE = 27;

var createEscapeHandler = function createEscapeHandler(targetFn) {
  return function (event) {
    if (event.keyCode === ESCAPE_KEY_CODE) {
      targetFn();
    }
  };
};

function Drawer(props) {
  var open = props.open,
      onClose = props.onClose,
      children = props.children,
      direction = props.direction,
      desktopDirection = props.desktopDirection,
      id = props.id,
      lockScroll = props.lockScroll,
      width = props.width,
      className = props.className;
  var drawerContext = React.useContext(DrawerContext);

  var _useState = React.useState(drawerContext.hideCloseButton),
      _useState2 = slicedToArray.slicedToArray(_useState, 2),
      hideCloseButton = _useState2[0],
      setButtonHidden = _useState2[1];

  var handleCloseButtonToggle = function handleCloseButtonToggle() {
    setButtonHidden(!hideCloseButton);
  };

  React.useEffect(function () {
    var handleEscape = createEscapeHandler(onClose);

    if (open) {
      window.addEventListener('keydown', handleEscape, false);
    }

    return function () {
      window.removeEventListener('keydown', handleEscape, false);
    };
  }, [open, onClose]);
  var handleBodyOverlayClick = React.useCallback(function (event) {
    var isTheBodyOverlayClicked = event.target.getAttribute('role') === 'dialog';

    if (isTheBodyOverlayClicked) {
      onClose();
    }
  }, [onClose]);
  return /*#__PURE__*/React__default['default'].createElement(DrawerContext.Provider, {
    value: {
      hideCloseButton: hideCloseButton,
      toggleCloseButton: handleCloseButtonToggle
    }
  }, /*#__PURE__*/React__default['default'].createElement(BodyOverlay, {
    className: className,
    role: "dialog",
    onClick: handleBodyOverlayClick,
    open: open
  }, /*#__PURE__*/React__default['default'].createElement(DrawerContainer, {
    open: open,
    direction: direction,
    desktopDirection: desktopDirection,
    id: id,
    width: width
  }, open && children({
    DrawerHeader: DrawerHeader,
    DrawerCloseButton: DrawerCloseButton,
    DrawerContent: DrawerContent
  }))), /*#__PURE__*/React__default['default'].createElement(components_LockScroll_LockScroll['default'], {
    lockScroll: lockScroll,
    open: open
  }));
}

Drawer.defaultProps = {
  className: undefined,
  direction: 'right',
  desktopDirection: 'right',
  lockScroll: true,
  width: '30rem'
};
Drawer.propTypes = {
  /** The components that will be rendered inside the Drawer */
  children: index.propTypes.func.isRequired,

  /** The class that will be applied to the HTML element */
  className: index.propTypes.string,

  /** The Direction of the opening animation on the desktop breakpoint */
  desktopDirection: index.propTypes.oneOf(['top', 'right', 'bottom']),

  /** The Direction of the default opening animation */
  direction: index.propTypes.oneOf(['top', 'right', 'bottom']),

  /** The id property that will be applied to the HTML element */
  id: index.propTypes.string.isRequired,

  /** A property to determine if the scroll of the page will be locked when Drawer is open */
  lockScroll: index.propTypes.bool,

  /** A function responsible to close the Drawer */
  onClose: index.propTypes.func.isRequired,

  /** A property to determine if the drawer is open */
  open: index.propTypes.bool.isRequired,

  /** A property to determine the width size of the container */
  width: index.propTypes.string
};

exports.ESCAPE_KEY_CODE = ESCAPE_KEY_CODE;
exports.default = Drawer;
//# sourceMappingURL=Drawer.js.map
